<form *ngIf="form" [formGroup]="form">
  <div class="row no-gutters" *ngIf="!readOnly">
    <div class="col-12 col-lg-3 pr-lg-1" style="padding-left: 30.44px;">
      <!-- [ngClass]="{'col-lg-8': pricing, 'col-lg-7': !pricing}" -->
      <div class="row pb-1">
        <!-- <div class="col-1 pt-2 pl-1 pr-0 text-right">
          &nbsp;
        </div> -->
        <div class="col-12 pl-1">
          <!-- <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">name</mat-label>
            <input matInput name="detail" formControlName="detail" type="text" (input)="calculateTotals()"
              [readonly]="readOnly">
          </mat-form-field> -->
          <app-expense-autocomplete [text]="item.detail || ''" (selected)="onSelected($event)"
            (textChange)="onChanged($event)" [readOnly]="readOnly">
          </app-expense-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-block d-lg-none">
          <mat-form-field appearance="outline">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" formControlName="description" [readonly]="readOnly" placeholder="Descripción"
              (input)="calculateTotals()" [errorStateMatcher]="customErrorStateMatcher">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-8"><!-- [ngClass]="{'col-lg-4': pricing, 'col-lg-4': !pricing}" -->
      <div class="row no-gutters">
        <div class="col-6 col-md-2 pl-1">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Fecha</mat-label>
            <input matInput name="date" formControlName="date" type="date" style="line-height: 11px !important;"
              class="d-flex justify-content-start" #dobInput (input)="calculateTotals()" [readonly]="readOnly">
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 pl-1">
          <mat-form-field appearance="outline">
            <mat-label>
              Proveedor
              <span *ngIf="!(vendorsTerm?.length || f['vendor']?.value)">(Escribe para buscar...)</span>
            </mat-label>
            <input matInput type="text" name="vendor" formControlName="vendor" [matAutocomplete]="autoVendor" 
            (input)="calculateTotals()"/>
            <mat-autocomplete #autoVendor="matAutocomplete" [displayWith]="displayVendorsFn"
            (optionSelected)="calculateTotals()">
              <mat-option *ngFor="let vendor of $vendors | async" [value]="vendor">
                {{ vendor.name ?? 'Sin nombre' }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-error *ngIf="f['vendor'].hasError('notFound')">
            Proveedor no válido. Selecciona uno de la lista.
          </mat-error>

          <!-- <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Proveedor</mat-label>
            <input matInput type="text" placeholder="Buscar proveedor..." (input)="filterVendors($event)" />
            <mat-select formControlName="vendor" (selectionChange)="calculateTotals()" [ngClass]="{'readonly-select': readOnly}"
              [disabled]="readOnly">
              <mat-option *ngFor="let vendor of filteredVendors" [value]="vendor">{{vendor.name}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>
        <div class="col-6 col-md-1 pl-1">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Cantidad</mat-label>
            <input matInput name="quantity" formControlName="quantity" type="number" (input)="calculateTotals()"
              [readonly]="readOnly">
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Costo</mat-label>
            <input matInput name="amount" formControlName="amount" type="number" (input)="calculateTotals()"
              [readonly]="readOnly">
          </mat-form-field>
        </div>

        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Subtotal</mat-label>
            <input matInput type="text" class="number" formControlName="subtotal" readonly>
          </mat-form-field>
        </div>
        <div class="col-6 col-md-1 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline" *ngIf="f['taxPercentage'].value != undefined">
            <mat-label class="d-lg-none d-block">(%)Impuestos</mat-label>
            <input matInput type="text" class="number" formControlName="taxPercentage" [readonly]="readOnly"
              (input)="calculateTotals()">
          </mat-form-field>
          <div class="text-right pt-4" *ngIf="f['taxPercentage'].value == undefined" style="width: 100%"> </div>
        </div>

        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Total</mat-label>
            <input matInput type="text" class="number" formControlName="total" readonly>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-1 pl-lg-1" style="display: flex; align-items: center;" *ngIf="!readOnly">
      <button class="btn btn-outline p-1 m-0" (click)="removeItem()" style="margin-left: auto; margin-top: auto;">
        <i class="material-icons">delete</i>
      </button>
    </div>


    <div class="col-11 d-none d-lg-block pl-4">
      <mat-form-field appearance="outline">
        <mat-label>Descripción</mat-label>
        <input matInput type="text" formControlName="description" [readonly]="readOnly" (input)="calculateTotals()"
          [errorStateMatcher]="customErrorStateMatcher">
      </mat-form-field>
    </div>
  </div>

  <!-- ------readOnly------- -->

  <div class="row mx-1" *ngIf="readOnly">
    <div class="col-12 mb-1 mt-1 pb-1" style="border-radius: 8px; border-bottom: 1px solid #EAE8F5;">
      <div class="row">
        <div class="col-12 col-lg-3 d-flex align-items-center justify-content-center">
          <!--[ngClass]="{'col-lg-6': pricing, 'col-lg-4': !pricing}"-->
          <div class="col-12 pl-2 text-left bold-item text-md-left text-center">
            {{item.detail}}
          </div>
        </div>
        <div class="col-12 col-lg-8"> <!-- [ngClass]="{'col-lg-4': pricing, 'col-lg-4': !pricing}" -->
          <div class="row align-items-center">
            <div class="col-6 col-md-2 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Fecha: </div>
              {{item.date | date:'dd/MM/yyyy'}}
            </div>
            <div class="col-6 col-md-2 text-left" *ngIf="pricing">
              <div class="d-md-none d-inline">Proveedor: </div>
              {{item.vendor?.name || ' - - '}}
            </div>
            <div [ngClass]="{'col-6 col-md-1': pricing, 'col-12': !pricing}" class="text-right">
              <div class="d-md-none d-inline">Cantidad: </div>
              {{item.quantity}}
            </div>
            <div class="col-6 col-md-2 text-right" *ngIf="pricing">
              <div class="d-md-none d-inline">Costo: </div>
              {{(item.amount || 0) | money: { needSymbol:false } }}
            </div>
            <div class="col-6 col-md-2 text-right" *ngIf="pricing">
              <div class="d-md-none d-inline">Subtotal: </div>
              {{item.subtotal || 0 | money: { needSymbol:false } }}
            </div>
            <div class="col-6 col-md-1 text-right" *ngIf="pricing">
              <div class="d-md-none d-inline">Impuesto: </div>
              {{item.taxPercentage}}%
            </div>
            <div class="col-6 col-md-2 text-right" *ngIf="pricing">
              <div class="d-md-none d-inline">Total: </div>
              {{(item.total || 0) | money: { needSymbol:false } }}
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-1 d-none d-lg-block">
          <div class="col-12"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-4 text-md-left text-center" *ngIf="pricing">
          <div class="d-md-none d-inline">Descripción:</div>
          &nbsp;{{item.description}}
        </div>
      </div>
    </div>

  </div>
</form>